import React, { useMemo } from 'react';
import ReactRoutesContext from './ReactRoutesContext';

type ReactRoutesProviderProps = {
  children: React.ReactNode;
};

const isReactAppMounted = !!document.getElementById('react-app-root');

function ReactRoutesProvider({ children }: ReactRoutesProviderProps) {
  const contextValue = useMemo(
    () => ({
      isReactAppMounted,
    }),
    [],
  );

  return (
    <ReactRoutesContext.Provider value={contextValue}>
      {children}
    </ReactRoutesContext.Provider>
  );
}

export default ReactRoutesProvider;
